module.exports = __webpack_public_path__ + "static/media/05.315219f7.png";